import { MAX_UNREAD_COUNT } from 'constants/ChatConstants';

export const getUnreadConversations = (value) => {
  const isCountExceedingMax = value >= MAX_UNREAD_COUNT;
  return isCountExceedingMax ? `${MAX_UNREAD_COUNT}+` : value;
};
